import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Navbar from '../components/App/Navbar'
import Footer from '../components/App/Footer'
import Layout from '../components/App/Layout'
import Banner from '../components/Index/Banner'
import OurSolutions from '../components/Index/OurSolutions'
import OurServices from '../components/Index/OurServices'
import OurFeatures from '../components/Index/OurFeatures'
import TeamMember from '../components/Index/TeamMember'
import RecentProjects from '../components/Index/RecentProjects'
import Pricing from '../components/Index/Pricing'
import Testimonials from '../components/Index/Testimonials'
import Partner from '../components/Index/Partner'
import ProjectStartArea from '../components/Index/ProjectStartArea'
import OurBlog from '../components/Index/OurBlog'
import SEO from '../components/App/SEO'

const Home = () => {
  const { siteMeta, seoSection } = useStaticQuery(
    graphql`
      query {
        siteMeta: allSite {
          edges {
            node {
              siteMetadata {
                defaultTitle
                defaultDescription
              }
            }
          }
        }
        seoSection: allContentfulHomeItServices {
          edges {
            node {
              seoTitle
              seoDescription
            }
          }
        }
      }
    `
  )

  let titleSeo = siteMeta.edges[0].node.defaultTitle
  let descSeo = siteMeta.edges[0].node.defaultDescription
  if (seoSection) {
    titleSeo = seoSection.edges[0].node.seoTitle
    descSeo = seoSection.edges[0].node.seoDescription
  }

  return (
    <Layout>
      <SEO title={titleSeo} description={descSeo} />
      <Navbar />
      <Banner />
      <OurSolutions />
      <OurServices />
      <OurFeatures />
      <TeamMember />
      <RecentProjects />
      <Pricing />
      <Testimonials />
      <Partner />
      <OurBlog />
      <ProjectStartArea />
      <Footer />
    </Layout>
  )
}

export default Home
